import { render, staticRenderFns } from "./SingleTagInput.vue?vue&type=template&id=dfae9cb8&scoped=true&"
import script from "./SingleTagInput.vue?vue&type=script&lang=js&"
export * from "./SingleTagInput.vue?vue&type=script&lang=js&"
import style0 from "./SingleTagInput.vue?vue&type=style&index=0&id=dfae9cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfae9cb8",
  null
  
)

export default component.exports